export default __webpack_public_path__ + "static/media/ABCLOCAL.df47c23a.png";